export const APPLICATION_SUGGESTIONS = [
    'Agricultural',
    'Airports',
    'Campus',
    'Commercial',
    'Community',
    'Data Centers',
    'DC Fast Charging',
    'Healthcare Facilities',
    'Industrial',
    'Military',
    'Mining Operations',
    'Office',
    'Ports',
    'Remote (Off-Grid)',
    'Residential',
    'Telecommunications',
    'Urban',
];
